var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.onlyPrint}},[_vm._v(" 打印 ")]),_c('el-button',{attrs:{"type":"primary","icon":"printer","size":"small"},on:{"click":_vm.toPdf}},[_vm._v(" pdf ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }